import { createStructuredSelector } from 'reselect'

import { selectBomDataForCart } from 'product_tabs/tab_parts/selector/selectors';
import { selectAssemblyDataForCart } from 'product_tabs/tab_assembly/selector/selector';

export const selectDataForCart = createStructuredSelector({
  parts: selectBomDataForCart,
  assembly: selectAssemblyDataForCart,
});